import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "services/recruitersService";
import useUserId from "./useUserId2";

const usePostsChartData = () => {
  const [postsData, setPostsData] = useState({ labels: [], datasets: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const userId = useUserId();

  useEffect(() => {
    const loadPostsChartData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await apiClient.get(`recruiters/${userId.userId}/candidates_applied_to_RHposts/`);

        if (response.status === 401) {
          navigate("/login");
          return;
        }

        const json = response.data;

        if (Object.keys(json).length === 0) {
          setPostsData({ labels: [], datasets: [] });
          setLoading(false);
          return;
        }

        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

        const postIds = new Set();
        const monthlyData = {};

        Object.entries(json).forEach(([month, posts]) => {
          const monthIndex = parseInt(month) - 1;
          const monthName = monthNames[monthIndex];

          Object.entries(posts).forEach(([postId, data]) => {
            postIds.add(postId);
            if (!monthlyData[postId]) {
              monthlyData[postId] = Array(12).fill(0);
            }
            monthlyData[postId][monthIndex] = data.total_candidates;
          });
        });

        const chartData = {
          labels: monthNames,
          datasets: Array.from(postIds).map((postId, index) => ({
            label: `Post ${postId}`,
            data: monthlyData[postId],
            borderColor: getColor(index),
            backgroundColor: getColor(index, 0.5),
            borderWidth: 2,
            fill: false,
          })),
        };

        setPostsData(chartData);
      } catch (err) {
        console.error("Error fetching posts data:", err);
        setError("Failed to load posts data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    if (userId && userId.userId) {
      loadPostsChartData();
    }
  }, [userId.userId, navigate]);


  return { postsData, loading, error };
};

// Helper function to generate colors
const getColor = (index, opacity = 1) => {
  const colors = [
    "#E2E8F0", 
    "#94A3B8", 
    "#475569", 
    "#1E293B", 
    "#003CBA",
  ];
  return colors[index % colors.length].replace("OPACITY", opacity);
};

export default usePostsChartData;